import axios from 'axios'
import toast from 'react-hot-toast'
import { logoutClear, getUserFromToken } from 'src/utility/Utils'
import { store } from '../../redux/store'
import { logout } from '../../redux/auth/authSlice'

// API URL'yi doğru formatta tanımlayalım
const API_URL = import.meta.env.VITE_APP_API_URL?.replace(/\/$/, '')

console.log('API URL:', API_URL) // URL'yi konsola yazdır

// API Response kodları (Swagger'dan)
const API_CODES = {
  SUCCESS: 1000,
  WARNING: 1500,
  DEPRECATED: 1501,
  INTERNAL_SERVER_ERROR: 2000,
  UNDER_MAINTENANCE: 2001,
  ERROR: 3000,
  VALIDATION_ERROR: 3001,
  FORBIDDEN: 3002,
  NOT_FOUND: 3003,
  INVALID_REQUEST: 3004,
  OUT_OF_STOCK: 3005,
  QUOTA_EXCEEDED: 3006,
  NOT_ENABLED: 3007,
  USER_ALREADY_EXISTS: 3008,
  AUTH_METHOD_NOT_ACTIVE: 3009,
  INVALID_SESSION: 3990,
  SESSION_EXPIRED: 3991,
  VERIFICATION_REQUIRED: 3992,
  UNAUTHORIZED: 3993
}

// Axios instance oluşturalım
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Accept-Language': `${localStorage.getItem('i18nextLng')}`,
    'Platform': 'web'
  },
  timeout: 30000 // 30 saniye timeout
})

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Sessiz hata kontrolü - X-Silent-Error header'ı varsa hata mesajı gösterme
    const isSilentError = error.config?.headers?.['X-Silent-Error'] === 'true'
    
    if (isSilentError) {
      // Sessiz hata - sadece console'a log at
      console.log('Silent API Error:', error.response?.data)
      return Promise.reject(error)
    }

    // Hata durumunda backend'den gelen mesajı göster
    if (error.response) {
      const { status: httpStatus, data } = error.response
      
      // API'nizin standart hata formatını kontrol et
      if (data && typeof data === 'object') {
        const { status, code, message, data: errorData } = data
        
        // Backend'den gelen mesajı al - message yoksa data field'ını kontrol et
        let errorMessage = message || data.data || 'Bir hata oluştu'
        
        // API koduna göre özel işlemler
        if (code) {
          switch (code) {
            case API_CODES.UNAUTHORIZED:
            case API_CODES.INVALID_SESSION:
            case API_CODES.SESSION_EXPIRED:
              toast.error('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.')
              localStorage.removeItem('token')
              window.location.href = '/login'
              break
              
            case API_CODES.VALIDATION_ERROR:
              // Eğer validasyon hatası detayları varsa onları göster
              if (errorData && typeof errorData === 'object') {
                Object.keys(errorData).forEach(key => {
                  const fieldErrors = errorData[key]
                  if (Array.isArray(fieldErrors)) {
                    fieldErrors.forEach(err => toast.error(`${key}: ${err}`))
                  } else {
                    toast.error(`${key}: ${fieldErrors}`)
                  }
                })
              } else {
                toast.error(errorMessage)
              }
              break
              
            case API_CODES.FORBIDDEN:
              toast.error(errorMessage || 'Bu işlem için yetkiniz bulunmuyor')
              break
              
            case API_CODES.NOT_FOUND:
              toast.error(errorMessage || 'İstenen kaynak bulunamadı')
              break
              
            case API_CODES.USER_ALREADY_EXISTS:
              toast.error(errorMessage || 'Bu kullanıcı bilgileri zaten kayıtlı')
              break
              
            case API_CODES.OUT_OF_STOCK:
              toast.error(errorMessage || 'Stok yetersiz')
              break
              
            case API_CODES.QUOTA_EXCEEDED:
              toast.error(errorMessage || 'Limit aşıldı')
              break
              
            case API_CODES.NOT_ENABLED:
              toast.error(errorMessage || 'Bu özellik etkin değil')
              break
              
            case API_CODES.VERIFICATION_REQUIRED:
              toast.error(errorMessage || 'Hesap doğrulaması gerekli')
              break
              
            case API_CODES.INTERNAL_SERVER_ERROR:
              toast.error(errorMessage || 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.')
              break
              
            case API_CODES.UNDER_MAINTENANCE:
              toast.error(errorMessage || 'Sistem bakımda. Lütfen daha sonra tekrar deneyin.')
              break
              
            default:
              toast.error(errorMessage)
          }
        } else {
          // Kod yoksa HTTP status'a göre işlem yap
          switch (httpStatus) {
            case 400:
              toast.error(errorMessage || 'Geçersiz istek')
              break
            case 401:
              toast.error('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.')
              localStorage.removeItem('token')
              window.location.href = '/login'
              break
            case 403:
              toast.error(errorMessage || 'Bu işlem için yetkiniz bulunmuyor')
              break
            case 404:
              toast.error(errorMessage || 'İstenen kaynak bulunamadı')
              break
            case 422:
              toast.error(errorMessage || 'Girilen veriler geçersiz')
              break
            case 500:
              toast.error(errorMessage || 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.')
              break
            default:
              toast.error(errorMessage)
          }
        }
      } else {
        // Standart olmayan hata formatı
        const errorMessage = typeof data === 'string' ? data : 'Bilinmeyen bir hata oluştu'
        toast.error(errorMessage)
      }
    } else if (error.request) {
      // İstek gönderildi ama yanıt alınamadı
      toast.error('Bağlantı hatası. Lütfen internet bağlantınızı kontrol edin.')
    } else {
      // İstek hazırlanırken hata oluştu
      toast.error('İstek hatası: ' + error.message)
    }

    return Promise.reject(error)
  }
)

// Global axios instance'ı kullan
axios.defaults = axiosInstance.defaults

export default axiosInstance
